<template>

    <v-modal title="Tag Customer">
        <template #body>
            <v-alert :message="error" />
            <v-form-group v-if="tags.length" dir="ver" label="Select Tags">
                <v-list grouped>
                    <v-list-item size="sm" v-for="t in tags" :key="t.id">
                        <div class="d-flex align-items-center">
                            <v-swatch class="mr-10" :color="t.color" :size="16" />
                            <span>{{ t.name }}</span>
                        </div>
                        <div>
                            <v-button
                                class="float-right"
                                size="xs"
                                :btn-style="!params.tag_ids.find(i => i === t.id) ? 'secondary' : 'success'"
                                :btn-label="!params.tag_ids.find(i => i === t.id) ? 'Select' : 'Selected'"
                                @click.native="toggleTag(t.id)">
                            </v-button>
                        </div>
                    </v-list-item>
                </v-list>
            </v-form-group>
            <v-form-group dir="ver" label="Add New Tags">
                <v-input :model="params.tags" @input="params.tags = $event" placeholder="Separate multiple tags with a comma." />
            </v-form-group>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" :loading="loading" @click.native="updateTags">Update Tags</v-button>
        </template>
    </v-modal>

</template>

<script>

import CustomerApi from '@api/CustomerApi'

export default {

    props: {
        customer: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            error: null,
            params: {
                tag_ids: this.customer.tags.map(ct => { return ct.tag_id }),
                tags: '',
            },
        }
    },

    computed: {

        tags() {
            return this.$store.getters.project.tags;
        },

    },

    methods: {

        toggleTag(id) {
            if (this.params.tag_ids.find(i => i === id)) {
                let index = this.params.tag_ids.indexOf(id);
                this.params.tag_ids.splice(index, 1);
            } else {
                this.params.tag_ids.push(id);
            }
        },

        updateTags() {
            this.loading = true;
            CustomerApi.updateTags(this.customer.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$emit('saved');
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                    this.$store.commit('showModal', false);
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
